import React, { useState, useEffect} from 'react';
import HALO from 'vanta/dist/vanta.halo.min'
import styles from './Solution.module.css'

const Solution = () => {
    const [vantaEffect, setVantaEffect] = useState(null);
    const [xOffsetValue, setXOffsetValue] = useState(window.innerWidth <= 768 ? 0 : -0.1);
    const [yOffsetValue, setYOffsetValue] = useState(0.15);
    const [sizeValue, setSizeValue] = useState(0.8);

    const updateValues = () => {
        setXOffsetValue(window.innerWidth <= 768 ? 0 : -0.1);
        setYOffsetValue(window.innerWidth <= 768 ? 0 : 0.15);
        setSizeValue(window.innerWidth <= 768 ? 0.6 : 0.8);
    };

    useEffect(() => {
        window.addEventListener('resize', updateValues);

        // Initial check
        updateValues();

        return () => {
            window.removeEventListener('resize', updateValues);
        };
    }, []);

    useEffect(() => {
        if (!vantaEffect) {
            setVantaEffect(HALO({
                el: "#vanta",
                mouseControls: true,
                touchControls: true,
                gyroControls: false,
                baseColor: 0x300e57,
                backgroundColor: 0x030014,
                amplitudeFactor: 1.20,
                xOffset: xOffsetValue,
                yOffset: yOffsetValue,
                size: sizeValue,
            }));
        }
        return () => {
            if (vantaEffect) vantaEffect.destroy();
        };
    }, [vantaEffect, xOffsetValue, yOffsetValue, sizeValue]);
  return (
    <section className={styles.solution_area}>
        <h2>幅広い<span>状態</span>に対応</h2>
        <div className={styles.contents}>
            <ul>
                <li>コーディングまでお願いしたい</li>
                <li>ドメインの取得から行ってほしい</li>
                <li>現行のランディングページを改善したい</li>
                <li>サーバーの立ち上げまでサポートしてほしい</li>
                <li>WordPressで構築したい</li>
            </ul>
            <div className={styles.vanta} id='vanta'></div>
        </div>
    </section>
  )
}

export default Solution